import './index.css';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { s as styles } from './base-text-DqfkG6Rh.js';

const TextDynamic = ({ stretched, ...props }) => {
    const forceDisabled = useDisabled();
    return (jsx("div", { className: classNames([styles.textDynamic, stretched && styles.textDynamicStretched], {
            [styles.textDynamicDisabled]: forceDisabled,
        }), ...props }));
};

export { TextDynamic };
//# sourceMappingURL=TextDynamic.js.map
